import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  makeStyles,
  Typography,
} from "@material-ui/core";
import React, { useState } from "react";
import { ScidQrCode } from "./ScidQrCode";
import { Text } from "@dna/react";
import styles from "./QrModal.module.scss";
import { DateConverter } from "../../common/date-display/DateDisplay";

export interface IQrCodeProps {
  scriptNumber: string | undefined;
  chartUpdated?: string | undefined | null;
  chartExpiry?: string | undefined | null;
  prescriptionDate?: string | undefined | null;
  patientName?: string;
  productName?: string;
  flag?: boolean | undefined;
}
const useStyles = makeStyles(() => ({
  paper: { maxWidth: "350px" },
}));

const generateTitle = (patientName?: string, productName?: string) => {
  if (productName) {
    return (
      <>
        <div>ePrescription for</div>
        <div>{productName}</div>
      </>
    );
  }
  if (patientName) {
    return (
      <>
        <div>Chart script for</div>
        <div>{patientName}</div>
      </>
    )
  }
  return null;
};

export const QrModal = ({
  scriptNumber,
  chartUpdated,
  chartExpiry,
  prescriptionDate,
  patientName,
  productName,
  flag,
}: IQrCodeProps) => {
  const classes = useStyles();
  const [open, setopen] = useState(false);
  const handleClickOpen = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    setopen(true);
  };
  const handleClickClose = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setopen(false);
  };

  return (
    <>
      <div className={flag ? styles.link : ''} onClick={handleClickOpen}>
        <Text UNSAFE_style={{ fontSize: "14px" }}>
          {scriptNumber}
        </Text>
      </div>

      <Dialog
        classes={{ paper: classes.paper }}
        onClick={(e: any) => {
          e.stopPropagation();
        }}
        open={!!flag && open}
        onClose={handleClickClose}
      >
        <DialogTitle className={styles.qrTitle}>{generateTitle(patientName, productName)}</DialogTitle>
        <DialogContent dividers>
          <Typography>
            <ScidQrCode scriptNumber={scriptNumber} />
          </Typography>
          <Typography className={styles.qrScriptNumber}>
            {scriptNumber}
          </Typography>
          {chartUpdated && (
            <Typography className={styles.chartTime}>
              Chart updated {DateConverter(chartUpdated)}
            </Typography>
          )}
          {chartExpiry && (
            <Typography className={styles.chartTime}>
              Chart expiry {DateConverter(chartExpiry)}
            </Typography>
          )}
          {prescriptionDate && (
            <Typography className={styles.chartTime}>
              Prescription date {DateConverter(prescriptionDate)}
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button className={styles.qrCloseButton} onClick={handleClickClose}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
